<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
         <div style="margin:4.444vh 0px 0px 3.0208vw;">
          <div style="float:left">
            <div class="english">ENTERTAINMENT</div>
          </div>
          <div class="chinese">娱乐</div>
        </div>

        <!-- 底部 -->
        <div class="footerMenu" style="margin-left:1.71875vw">
          <!-- <div
            :class="classNameA"
            @mouseover="classNameA = 'colAHover'"
            @mouseout="classNameA = 'colA'"
            @click="openTypeLise(4)"
          >
            <div class="cha">︻</div>
            <div class="chaFontEnglish" style="margin-top:0.74074vh">K</div>
            <div class="chaFontEnglish" style="margin-top:1.5740vh">T</div>
            <div class="chaFontEnglish" style="margin-top:1.5740vh">V</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div> -->
          <!-- <div
            :class="classNameB"
            @mouseover="classNameB = 'colAHover'"
            @mouseout="classNameB = 'colA'"
            @click="openTypeLise(3)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">彩</div>
            <div class="chaFont">弹</div>
            <div class="chaFont">野</div>
            <div class="chaFont">战</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div> -->
          <!-- <div
            :class="classNameC"
            @mouseover="classNameC = 'colAHover'"
            @mouseout="classNameC = 'colA'"
            @click="openTypeLise(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">高</div>
            <div class="chaFont" style="margin-top:1.5740vh">尔</div>
            <div class="chaFont" style="margin-top:1.5740vh">夫</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div> -->
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click="openTypeLise(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">演</div>
            <div class="chaFont">出</div>
            <div class="chaFont">节</div>
            <div class="chaFont">目</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import  "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "Entertainment",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu",8);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "EnterTab";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/entertainment/enterSwitch.vue